<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.type_name" placeholder="请输入课程分类" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="typeName" label="名称"></el-table-column>
            <el-table-column prop="typeImage" label="图片">
                <template slot-scope="scope">
                    <el-image style="width: 50px; height: 50px;" :src="img" fit="cover"
                        :preview-src-list="getImageSrcList(scope.row.typeImage)" :initial-index="index"
                        v-for="(img, index) in getThumbImageSrcList(scope.row.typeImage)"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="productCount" label="课程数量"></el-table-column>
            <el-table-column prop="typeSort" label="序号"></el-table-column>
            <el-table-column prop="typeDesc" label="简述"></el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.typeDate) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="名称">
                        <el-input v-model="handleInfo.typeName"></el-input>
                    </el-form-item>
                    <el-form-item label="图片">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('typeImage')">
                                <el-image class="upload-image" :src="getThumbImageSrc(img)" fit="cover"
                                    :preview-src-list="[getImageSrc(img)]"></el-image>
                                <div @click="uploadRemove('typeImage', index)" class="upload-remove">删除</div>
                            </div>
                            <el-upload :data="{ column: 'typeImage' }" accept=".jpg,.jpeg,.bmp,.png"
                                :headers="uploadHeaders" :multiple="false" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadSuccessSingle">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="序号">
                        <el-input v-model="handleInfo.typeSort"></el-input>
                    </el-form-item>
                    <el-form-item label="简述">
                        <el-input v-model="handleInfo.typeDesc"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin],
    data: function () {
        return {

        }
    },
    methods: {
    },
    created: async function () {
        this.tag = "TYPE";
        this.uploads.push({
            column: "typeImage",
            files: []
        });
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>